/* eslint-disable no-restricted-syntax */
import { useEffect, useState } from 'react';

export const useCheckVersion = () => {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [latestVersion, setLatestVersion] = useState('');

    useEffect(() => {
        const checkForUpdate = async () => {
            try {
                const currentVersion = localStorage.getItem('appVersion');

                // Fetch latest version.json (cache-busting param to prevent caching)
                const response = await fetch(`/version.json?t=${Date.now()}`, {
                    cache: 'no-store',
                });

                if (!response.ok) {
                    console.error('Failed to fetch version.json');
                    return;
                }

                const data = await response.json();
                setLatestVersion(data.version);

                // Compare versions
                if (data.version !== currentVersion) {
                    console.log(
                        `New version detected: ${data.version} (Current: ${currentVersion})`
                    );

                    // Store the new version
                    localStorage.setItem('appVersion', data.version);

                    // Mark update as available
                    setIsUpdateAvailable(true);

                    // **Unregister only the current service worker**
                    if ('serviceWorker' in navigator) {
                        navigator.serviceWorker
                            .getRegistration()
                            .then(async (registration) => {
                                await registration?.unregister();
                                console.log(
                                    'Unregistered old service worker...'
                                );
                            });
                    }
                }
            } catch (error) {
                console.error('Error checking version:', error);
            }
        };

        checkForUpdate();

        // Poll for updates every 30 minutes
        const interval = setInterval(checkForUpdate, 30 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return { isUpdateAvailable, latestVersion };
};
